import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "w-full max-w-4xl mx-auto px-4 py-2"
}
const _hoisted_3 = { class: "w-full h-auto flex justify-center items-start py-20 px-12 bg-gray-50 rounded-2xl" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "my-6 lg:my-10" }
const _hoisted_6 = { class: "text-28px lg-text-32px font-semibold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-18px lg-text-20px" }, "Vintage : 2022", -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"border-b\"></div><div class=\"mt-6 mb-16 lg:my-10 flex\"><div class=\"mx-2 py-2 text-18px lg-text-20px whitespace-nowrap\"> Location : </div><div class=\"flex flex-wrap items-center\"><div class=\"mx-2 my-2 px-4 py-2 bg-primary-2 rounded-full text-white text-16px lg-text-20px\"> Ban Tum, Phayao, Thailand </div><div class=\"mx-2 px-4 py-2 bg-primary-2 rounded-full text-white text-16px lg-text-20px\"> Forest name 2 </div></div></div>", 2)

import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import Moralis from 'moralis';
import useMoralis from '@/composables/useMoralis';
import { GetNFTsInventories } from '@/types/MoralisCloud';
import { BIODIVERSITY_NFT_ADDRESS, CARBON_NFT_ADDRESS } from '@/constants';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const moralis = useMoralis();

const nftType = computed(() => route.params.type as string);
const nftAddress = computed(() => route.params.address as string);
const nft = ref();

const userAddress = computed<string>(
  () => moralis.currect.User.current()?.attributes.ethAddress as string
);

onMounted(async () => {
  try {
    const result = await moralis.currect.Cloud.run<GetNFTsInventories>(
      'getNFTsInventories',
      {
        walletAddress: userAddress.value,
        nftAddress:
          nftType.value == 'carbon'
            ? CARBON_NFT_ADDRESS
            : BIODIVERSITY_NFT_ADDRESS,
        page_number: 1,
        size: 20,
      }
    );
    const find = result.entities.find((e) => e.nftAddress == nftAddress.value);
    if (find) nft.value = find;
  } catch (err) {
    moralis.handleMoralisError(err as Moralis.Error);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (nft.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: nft.value.nftImageURL,
              class: "w-full max-w-md h-auto",
              alt: ""
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(nft.value.nftDescription || 'n/a'), 1),
            _hoisted_7
          ]),
          _hoisted_8
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})